import { MultiSelect } from '@mantine/core';
import React, { useMemo } from 'react';

import { useGetLabels } from 'api/labels';

type LabelSelectorProps = {
  orgId: string;
  projectId?: string;
  value: string[];
  onChange: (labels: string[]) => void;
  placeholder?: string;
  label?: string;
  creatable?: boolean;
  disabled?: boolean;
};

export function LabelSelector({
  orgId,
  projectId,
  value,
  onChange,
  placeholder = 'Select labels',
  label = 'Labels',
  creatable = true,
  disabled = false,
}: LabelSelectorProps) {
  const { data: labels = [], isLoading } = useGetLabels(orgId, projectId);

  const labelOptions = useMemo(
    () =>
      labels.map((labelItem) => ({
        value: labelItem.name,
        label: labelItem.name,
        color: labelItem.color,
      })),
    [labels]
  );

  const handleCreate = (query: string): string | null => {
    const normalized = query.trim().toLowerCase();
    if (!normalized) {
      return null;
    }
    // Return the normalized name - parent component should handle creation
    return normalized;
  };

  return (
    <MultiSelect
      label={label}
      data={labelOptions}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchable
      creatable={creatable}
      disabled={disabled || isLoading}
      getCreateLabel={(query) => `+ Create "${query}"`}
      onCreate={handleCreate}
      nothingFound="No labels found"
      withinPortal
    />
  );
}
